import React, { Fragment, FC, useState } from "react";
import { Popover, Transition } from "@headlessui/react";
import { UserPlusIcon } from "@heroicons/react/24/outline";
import { GuestsObject } from "components/HeroSearchForm/type";
import ClearDataButton from "components/HeroSearchForm/ClearDataButton";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";

export interface GuestsInputViewProps {
  className?: string;
}

const GuestsInputView: FC<GuestsInputViewProps> = ({ className = "flex-1" }) => {

  const [guestAdultsInputValue, setGuestAdultsInputValue] = useState(sessionStorage.getItem("adults_guests") ? Number(sessionStorage.getItem("adults_guests")) : 2);
  const [guestChildrenInputValue, setGuestChildrenInputValue] = useState(sessionStorage.getItem("children_guests") ? Number(sessionStorage.getItem("children_guests")) : 0);
  const [guestInfantsInputValue, setGuestInfantsInputValue] = useState(sessionStorage.getItem("infants_guests") ? Number(sessionStorage.getItem("infants_guests")) : 0);
 

  const totalGuests =
    guestChildrenInputValue + guestAdultsInputValue + guestInfantsInputValue;
  
  sessionStorage.setItem("total_disp", totalGuests.toString());

  return (
    <Popover className={`flex relative ${className}`}>
      {({ open }) => (
        <>
          <div
            className={`flex-1 flex items-center focus:outline-none rounded-b-3xl ${
              open ? "shadow-lg" : ""
            }`}
          >
            <Popover
            id="guest-input"
              className={`relative z-10 flex-1 flex text-left items-center p-3 space-x-3 focus:outline-none`}
            >
              <div className="text-neutral-300 dark:text-neutral-400">
                <UserPlusIcon className="w-5 h-5 lg:w-7 lg:h-7" />
              </div>
              <div className="flex-grow">
                <span className="block xl:text-lg font-semibold">
                  {totalGuests || ""} Personas
                </span>
                <span className="block mt-1 text-sm text-neutral-400 leading-none font-light">
                  {totalGuests ? "Personas" : "Agregar Personas"}
                </span>
              </div>
            </Popover>
          </div>
        </>
      )}
    </Popover>
  );
};

export default GuestsInputView;
